import React from "react";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import Badge from "../../../components/Common/Badge/Badge";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import { FaPlus } from "react-icons/fa6";
import PropTypes from "prop-types";

function UsuariosDatatable({
  usuarios,
  atualizaStatusUsuario,
  togUsuarioModal,
}) {
  const colunas = React.useMemo(
    () => [
      {
        Header: "Nome",
        accessor: "nome",
      },
      {
        Header: "E-mail",
        accessor: "email",
      },
      {
        Header: "Status",
        accessor: "situacao",
        Cell: ({ row }) =>
          row.original.situacao === "Ativo" ? (
            <Badge color="success">Ativo</Badge>
          ) : (
            <Badge color="danger">Inativo</Badge>
          ),
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [
            <DropdownButton
              key={`situacao-${row.original.uid}`}
              onClick={() => {
                atualizaStatusUsuario(row.original.uid, row.original.ativo);
              }}
              color={row.original.situacao === "Ativo" ? "danger" : "success"}
              icon={
                row.original.situacao === "Ativo"
                  ? "mdi mdi-account-cancel"
                  : "mdi mdi-account-check"
              }
            >
              {row.original.situacao === "Ativo"
                ? "Inativar usuário"
                : "Ativar usuário"}
            </DropdownButton>,
            <DropdownButton
              key={`editar-${row.original.uid}`}
              onClick={() => {
                togUsuarioModal(false, row.original.uid);
              }}
              color="primary"
              icon="mdi mdi-account-edit"
            >
              Editar
            </DropdownButton>,
          ];
          return <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [atualizaStatusUsuario, togUsuarioModal]
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={usuarios}
      botoes={
        <ButtonRounded
          onClick={() => {
            togUsuarioModal(true);
          }}
          color="success"
          icon={<FaPlus />}
        >
          Novo usuário
        </ButtonRounded>
      }
    />
  );
}

UsuariosDatatable.propTypes = {
  usuarios: PropTypes.array.isRequired,
  atualizaStatusUsuario: PropTypes.func.isRequired,
  togUsuarioModal: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default UsuariosDatatable;
